import classNames from 'classnames'
import { Moon, SunMedium } from 'lucide-react'

import Label from '@/elements/Label'
import Flex from '@/elements/Flex'

import './FormToggle.scss'

interface FormToggleProps {
  name: string
  value: boolean
  label?: string
  disabled?: boolean
  labelPosition?: 'left' | 'right'
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
  isThemeSwitcher?: boolean
}

function FormToggle({
  name,
  onChange,
  label,
  labelPosition = 'left',
  value,
  disabled,
  className,
  isThemeSwitcher
}: FormToggleProps) {
  return (
    <Flex
      inline
      align='center'
      className={
        classNames(
          'form-field form-field-toggle',
          { 'theme-switcher': isThemeSwitcher },
          className
        )
      }
    >
      {labelPosition === 'left' && (
        <Label htmlFor={name} hidden={!label} position='left'>{label}</Label>
      )}
      <div className={classNames('field-inner', { disabled })}>
        <label className='toggle-switch' htmlFor={name}>
          <span className='toggle-slider'>
            {isThemeSwitcher && (
              <>
                <SunMedium size={18} />
                <Moon size={18} />
              </>
            )}
          </span>
        </label>
        <input
          type='checkbox'
          id={name}
          name={name}
          checked={value}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
      {labelPosition === 'right' && (
        <Label htmlFor={name} hidden={!label} position='right'>{label}</Label>
      )}
    </Flex>
  )
}

export default FormToggle
